import { Timer } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";

/**
 * ein rad der slotmaschine
 */

import MovieClip = createjs.MovieClip;

import Event = createjs.Event;
import TimerEvent = createjs.TimerEvent;

export class Poker2BanditRad {
    // BanditIcon1 .. 6 die symbole

    private PLAY_DURATION: number = 2000; // millisekunden 2x so lange drehen sich die räder

    private disp: MovieClip;
    private radNo: number = 0;
    private timer: Timer;
    private meldeFertigGedreht: Function;

    private ITEM_SONDERSYMBOL: number = -1;	//	negativ für die sterne zwischen den regulären symbolen
    private ITEM_ANZAHL: number = 6; 			// anzahl symbole auf einem rad
    private ITEM_WINKEL: number = 360 / this.ITEM_ANZAHL;

    private SPEED_MAX: number = 21;
    private SPEED_MIN: number = 3;
    private SPEED_STOPP_ZIEL: number = 5;
    private SPEED_BESCHLAEUNIGUNG_FACTOR: number = 1.2;
    private SPEED_VERZOEGERUNG_FACTOR: number = .96;
    private SPEED_MODUS_BESCHLAEUNIGEN: number = 1;
    private SPEED_MODUS_VERZOEGERN: number = 2;
    private SPEED_MODUS_STOPP_ZIEL: number = 3;
    private speedModus: number = 0;
    private speedDifferenzRotation: number = NaN;

    private gewinnAnzeigeWinkel: number = NaN; // Rad1=0, Rad2=270, Rad3=180 damit steht das trinksymbol in der anzeige
    private stopAtItem: number = 0; // 0..5

    /**
     * @param disp
     * @param radNo				rad 1..3
     * @meldeFertigGedreht		callback, wenn die animation beendet ist
     */
    constructor(disp: MovieClip, radNo: number, meldeFertigGedreht: Function) {
        this.disp = disp;
        this.radNo = radNo;
        this.meldeFertigGedreht = meldeFertigGedreht;
        this.gewinnAnzeigeWinkel = [0.0, 90.0, 180.0][radNo]; // diese Item-positionen gelten als ausgewählt
        this.timer = new Timer(this.PLAY_DURATION, 2);
    }

    /**
     *
     */
    public init(): void {
        var itemNo: number = 0;

        this.disp.rotation = this.gewinnAnzeigeWinkel;
        // damit die icons in der gewinnanzeige senkrecht stehen
        for (itemNo = 0; itemNo < this.ITEM_ANZAHL; itemNo++) {
            ((this.disp.getChildByName('BanditIcon' + (itemNo + 1))) as MovieClip).rotation = this.gewinnAnzeigeWinkel - itemNo * 60;
        }
        this.timer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.eventTimer));
        this.stopRotation();
    }

    /**
     * alles deinstallieren
     */
    public destroy(): void {
        this.meldeFertigGedreht = null;
        this.timer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.eventTimer));
        this.stopRotation();
    }

    /**
     * stoppen und vorbereiten zum drehen
     */
    private stopRotation(): void {
        this.stopAtItem = 5;
        this.speedDifferenzRotation = 0;
        this.disp.rotation = this.getSollWinkel();
        this.disp.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrame));
    }

    /**
     * starte das drehen
     */
    public startRotation(stopAtItem: number): void {
        if (stopAtItem == this.ITEM_SONDERSYMBOL) {
            // -1,-2,-3,-4,-5,-6
            stopAtItem = int(-1 - int(Math.random() * this.ITEM_ANZAHL));
        }
        else {
            // 0,1,2,3,4,5
            stopAtItem--;
        }
        this.stopAtItem = stopAtItem;
        this.speedDifferenzRotation = this.SPEED_MIN;
        this.speedModus = this.SPEED_MODUS_BESCHLAEUNIGEN;
        this.disp.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrame));
        this.setModus(this.SPEED_MODUS_BESCHLAEUNIGEN);
        this.timer.reset();
        this.timer.start();
    }

    /**
     * alle räder drehen sich schneller/ langsamer
     * @param speedModus	setzt beschleunigungs/ verzögerungs/ stopp modus
     */
    private setModus(speedModus: number): void {
        this.speedModus = speedModus;
    }

    /**
     * nach der zeit beschleunigen/ verzögern setzen
     * @param event	unbenutzt
     */
    private eventTimer(event: TimerEvent): void {
        switch (this.speedModus) {
            case this.SPEED_MODUS_BESCHLAEUNIGEN:
                this.setModus(this.SPEED_MODUS_VERZOEGERN);
                break;
            case this.SPEED_MODUS_VERZOEGERN:
                this.setModus(this.SPEED_MODUS_STOPP_ZIEL);
                break;
        }
    }

    /**
     * Enter_FRAME	rad drehen
     * @param event	unbenutzt
     */
    private onEnterFrame(event: Event): void {
        switch (this.speedModus) {
            case this.SPEED_MODUS_BESCHLAEUNIGEN:
                this.speedDifferenzRotation = Math.min(this.SPEED_MAX, this.speedDifferenzRotation * this.SPEED_BESCHLAEUNIGUNG_FACTOR);
                break;
            case this.SPEED_MODUS_VERZOEGERN:
                this.speedDifferenzRotation = Math.max(this.SPEED_MIN, this.speedDifferenzRotation * this.SPEED_VERZOEGERUNG_FACTOR);
                if (this.speedDifferenzRotation > this.SPEED_STOPP_ZIEL) {
                    // dreht sich noch zu schnell zum anhalten
                    break;
                }
            case this.SPEED_MODUS_STOPP_ZIEL:
                if (this.testZielItemErreicht()) {
                    // fertig
                    this.speedDifferenzRotation = 0;
                    this.disp.rotation = this.getSollWinkel();
                    this.disp.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrame));
                    this.meldeFertigGedreht();
                }
                break;
        }
        this.disp.rotation += this.speedDifferenzRotation;
    }

    /**
     * teste ob ziel-item in der nähe der anzeige ist, dann drehen stoppen
     * @return	true = stopp das drehen
     */
    private testZielItemErreicht(): boolean {
        var sollWinkel: number = this.getSollWinkel();
        var istWinkel: number = (this.disp.rotation + 360) % 360;
        return Math.abs(sollWinkel - istWinkel) < 2 * this.SPEED_MIN;
    }

    /**
     * bei diesem winkel stoppen
     * @return	ziel winkel des rades für dieses item
     */
    private getSollWinkel(): number {
        var sollWinkel: number = NaN;
        //
        if (this.stopAtItem < 0) // ITEM_SONDERSYMBOL
        {
            // -.5-(-x) = .5, 1.5, 2.5, ..
            sollWinkel = ((-.5 - this.stopAtItem) * this.ITEM_WINKEL - this.gewinnAnzeigeWinkel + 360) % 360;
        }
        else {
            sollWinkel = (this.stopAtItem * this.ITEM_WINKEL - this.gewinnAnzeigeWinkel + 360) % 360;
        }
        return sollWinkel;
    }

    //
    // ende
    //
}
